import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Management icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Management } from '@sravni/design-system-icons'
 *
 * <Management />
 * ```
 */
var Management = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Management", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.357 14.167H4.643A2.142 2.142 0 0 1 2.5 12.024V4.643c0-1.184.96-2.143 2.143-2.143h10.714c1.184 0 2.143.96 2.143 2.143v7.38c0 1.184-.96 2.144-2.143 2.144v0ZM11.667 14.167l.416 3.333M8.333 14.167 7.917 17.5M6.783 17.5h6.434M10 5.833V5M10 10.833v.834", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.553 10.238c.216.354.585.599 1.03.599H10.497a1.17 1.17 0 0 0 .284-2.305L9.218 8.14a1.17 1.17 0 0 1 .285-2.307H10.417c.444 0 .811.244 1.028.595", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Management };
//# sourceMappingURL=Management.js.map
